import { createSlice } from '@reduxjs/toolkit'

/**
 * Tracks whether the current customer-scoped session has hit a server-enforced
 * 403. Set by {@link forbiddenMiddleware} when any atlas query is rejected
 * with status 403; read by `CustomerLayout` to redirect to the unauthorized
 * page. Cleared when the layout mounts a new customer so a stale 403 never
 * strands a subsequent, authorized selection.
 */
interface ForbiddenState {
  isForbidden: boolean
}

const initialState: ForbiddenState = { isForbidden: false }

export const forbiddenSlice = createSlice({
  name: 'forbidden',
  initialState,
  reducers: {
    forbiddenDetected: (state) => {
      state.isForbidden = true
    },
    forbiddenCleared: (state) => {
      state.isForbidden = false
    },
  },
})

export const { forbiddenDetected, forbiddenCleared } = forbiddenSlice.actions
